<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M15.19 7.44a1.5 1.5 0 012.12 0l15.5 15.5a1.5 1.5 0 010 2.12l-15.5 15.5a1.5 1.5 0 01-2.12-2.12L29.628 24 15.189 9.56a1.5 1.5 0 010-2.12z"/></svg>